export default __webpack_public_path__ + "static/media/29.e42cbf76.png";